(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uc-arrivals-pairing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uc-arrivals-pairing')) {
  customElements.define('uc-arrivals-pairing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.buttons = Array.from(this.querySelectorAll('[data-na-design]'));
      this.panels = Array.from(this.querySelectorAll('[data-na-pair]'));
      if (!this.buttons.length) return;
      this.querySelector('[data-na-design-controls]').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.naDesign)));
      this.select(this.buttons[0].dataset.naDesign);
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-na-pair]');
        if (panel) this.select(panel.dataset.naPair);
      });
    }
    select(id) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.naDesign === id)));
      this.panels.forEach(panel => { panel.hidden = panel.dataset.naPair !== id; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-arrivals-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uc-arrivals-filter')) {
  customElements.define('uc-arrivals-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.buttons = Array.from(this.querySelectorAll('[data-na-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-na-product]'));
      this.querySelector('[data-na-controls]').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.naFilter, true)));
      this.select('featured', false);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-na-product]');
        if (card) this.select(card.dataset.naCategory, false);
      });
    }
    select(filter, announce) {
      let count = 0;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.naFilter === filter)));
      this.cards.forEach(card => {
        const show = filter === 'featured' ? card.dataset.naFeatured === 'true' : card.dataset.naCategory === filter;
        card.hidden = !show;
        if (show) count++;
      });
      this.querySelectorAll('[data-na-browse]').forEach(link => { link.hidden = filter !== 'featured' && link.dataset.naBrowse !== filter; });
      const status = this.querySelector('[data-na-status]');
      if (announce) status.textContent = status.dataset.naTemplate.replace('[count]', String(count));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-atelier-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uc-loop-film')) {
  class UcolorLoopFilm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.ready = true;
      this.events = new AbortController();
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.preference = null;
      this.visible = false;
      this.failed = false;
      this.playSequence = 0;
      this.pendingPlay = null;
      this.retryCount = 0;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.autoplay = false;
      this.button.hidden = false;
      const listen = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: this.events.signal });
      const refresh = () => {
        this.refreshVisibility();
        this.sync();
      };
      listen(this.video, 'playing', () => {
        this.dataset.hasFrame = 'true';
        this.dataset.playbackState = 'playing';
        this.retryCount = 0;
        clearTimeout(this.retryTimer);
        delete this.dataset.playError;
        this.updateButton();
        if (!this.shouldPlay()) this.video.pause();
      });
      listen(this.video, 'play', () => this.updateButton());
      listen(this.video, 'pause', () => this.updateButton());
      listen(this.video, 'loadedmetadata', () => this.sync());
      listen(this.video, 'canplay', () => this.sync());
      listen(this.video, 'error', () => {
        this.failed = true;
        this.dataset.playbackState = 'media-error';
        this.video.autoplay = false;
        clearTimeout(this.retryTimer);
        delete this.dataset.hasFrame;
        this.button.hidden = true;
      });
      listen(this.button, 'click', () => {
        this.preference = this.video.paused ? 'play' : 'pause';
        this.retryCount = 0;
        clearTimeout(this.retryTimer);
        this.visible = true;
        this.sync();
      });
      listen(this.mobile, 'change', () => {
        delete this.dataset.hasFrame;
        if (this.video.hasAttribute('src')) this.loadSource();
        refresh();
      });
      listen(this.reduced, 'change', refresh);
      listen(document, 'visibilitychange', refresh);
      listen(window, 'pageshow', refresh);
      listen(window, 'focus', refresh);
      listen(window, 'resize', refresh, { passive: true });
      const retryAfterGesture = event => {
        if (this.contains(event.target) || this.preference === 'pause') return;
        if (this.video.paused && this.shouldPlay()) {
          this.retryCount = 0;
          clearTimeout(this.retryTimer);
          this.sync();
        }
      };
      listen(document, 'pointerdown', retryAfterGesture, { passive: true });
      listen(document, 'keydown', retryAfterGesture);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[entries.length - 1];
          this.visible = entry.isIntersecting && entry.intersectionRatio > 0;
          this.sync();
        }, { threshold: [0, 0.01] });
        this.observer.observe(this);
      } else {
        listen(window, 'scroll', refresh, { passive: true });
      }
      refresh();
      this.layoutFrame = requestAnimationFrame(() => {
        if (this.ready && this.isConnected) refresh();
      });
      this.updateButton();
    }
    refreshVisibility() {
      const rect = this.getBoundingClientRect();
      const height = window.innerHeight || document.documentElement.clientHeight;
      const width = window.innerWidth || document.documentElement.clientWidth;
      this.visible = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < height && rect.left < width;
    }
    playbackReason() {
      if (this.failed) return 'media-error';
      if (this.preference === 'pause') return 'user-paused';
      if (document.hidden) return 'background';
      if (!this.visible) return 'offscreen';
      if (this.preference === 'play') return 'ready';
      if (this.dataset.autoplay !== 'true') return 'autoplay-off';
      if (this.dataset.respectReducedMotion !== 'false' && this.reduced.matches) return 'reduced-motion';
      if (navigator.connection?.saveData) return 'data-saver';
      return 'ready';
    }
    shouldPlay() {
      return this.playbackReason() === 'ready';
    }
    loadSource() {
      const source = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
      if (!source) return false;
      if (this.video.getAttribute('src') !== source) {
        this.playSequence++;
        this.pendingPlay = null;
        this.retryCount = 0;
        clearTimeout(this.retryTimer);
        this.video.pause();
        delete this.dataset.hasFrame;
        this.video.src = source;
        this.video.load();
      }
      return true;
    }
    sync() {
      const reason = this.playbackReason();
      if (reason !== 'ready') {
        this.playSequence++;
        this.pendingPlay = null;
        this.video.autoplay = false;
        clearTimeout(this.retryTimer);
        this.video.pause();
        this.dataset.playbackState = reason;
        this.updateButton();
        return;
      }
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.autoplay = true;
      if (!this.loadSource() || !this.video.paused || this.pendingPlay !== null) return;
      const sequence = ++this.playSequence;
      this.pendingPlay = sequence;
      this.dataset.playbackState = 'starting';
      let attempt;
      try {
        attempt = this.video.play();
      } catch (error) {
        attempt = Promise.reject(error);
      }
      this.updateButton();
      Promise.resolve(attempt).then(() => {
        if (sequence !== this.playSequence) return;
        this.pendingPlay = null;
        clearTimeout(this.retryTimer);
        if (!this.shouldPlay()) this.video.pause();
      }).catch(error => {
        if (sequence !== this.playSequence) return;
        this.pendingPlay = null;
        this.dataset.playError = error.name;
        this.dataset.playbackState = 'waiting-for-playback';
        this.updateButton();
        if (this.shouldPlay() && this.retryCount < 2) {
          this.retryCount++;
          clearTimeout(this.retryTimer);
          this.retryTimer = setTimeout(() => this.sync(), this.retryCount * 500);
        }
      });
    }
    updateButton() {
      const playing = !this.video.paused && !this.video.ended;
      const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', label);
      this.button.querySelector('span').textContent = label;
    }
    disconnectedCallback() {
      this.ready = false;
      this.playSequence++;
      this.pendingPlay = null;
      this.observer?.disconnect();
      this.events?.abort();
      clearTimeout(this.retryTimer);
      cancelAnimationFrame(this.layoutFrame);
      if (this.video) {
        this.video.autoplay = false;
        this.video.pause();
      }
    }
  }
  customElements.define('uc-loop-film', UcolorLoopFilm);
}

  } catch(e) { console.error(e); }
})();
})();
